import { useState, useEffect } from 'react';
import { _ReportItem } from '../../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import { PrintJson } from '../../../../theme/Component/PrintJson';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicTable, MASK_DATE } from '../../../../theme/Component/BasicTable';
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from '../../../../theme/Component/hooks/useModal';


interface Props {
    onChange: any;
    idReport: number;
    label?: string;
}
export const SelectAviableReportItems = ({ onChange, label, idReport }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ReportItem);
    const [renderValue, setRenderValue] = useState<string>("");
    
    const modal = useModal("Seleccione una Columna de Reporte", MODAL_md);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getAvailableReportItems(idReport).then(
            (resp) => {
                console.log(resp)
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const head = [
        { title: 'Nombre Columna', property: 'Name', visible: true, MASK_DATE },
        { title: 'Orden de Columna', property: 'ColumnIndex', visible: false },
        { title: 'Ancho de Columna', property: 'Width', visible: false },

    ]

    const selectItem = () => {
        if (bean.Name) {
            setRenderValue(`${bean.Name}`)
            modal.close();
            onChange?.(bean)
        } else {
            toast.error("Columna de Reporte no valida")
        }
    }

    return (
        <>
            <label>{label ? label : 'Columnas de Reportes'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </Modal>
        </>
    )
}